import Vue from 'vue'
import VueRouter from 'vue-router'
import authService from './vue.auth.service'

/* navMenuItems */
export const navMenuItems = [
  { title: 'navigation.home', route: 'home', icon: 'HomeIcon' },
  { title: 'navigation.list-contributors', route: 'list-contributors', icon: 'MailIcon' },
  { title: 'navigation.list-sad', route: 'list-sad', icon: 'UsersIcon' },
  { title: 'navigation.list-projects', route: 'list-projects', icon: 'GlobeIcon' },
  { title: 'navigation.list-donations', route: 'list-donations', icon: 'DollarSignIcon' },
  { title: 'navigation.list-givers', route: 'list-givers', icon: 'LoaderIcon' },

]

/* router */
Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/home',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import(/* webpackChunkName: "settings" */ './views/Settings.vue'),
    },
    {
      path: '/list/contributors',
      name: 'list-contributors',
      component: () => import(/* webpackChunkName: "list-contributors" */ './views/contributors/ContributorsList.vue'),
    },
    {
      path: '/list/projects',
      name: 'list-projects',
      component: () => import(/* webpackChunkName: "list-projects" */ './views/projects/ProjectsList.vue'),
      props: { isChildren: false },
    },
    {
      path: '/list/sad',
      name: 'list-sad',
      component: () => import(/* webpackChunkName: "list-projects" */ './views/projects/ProjectsList.vue'),
      props: { isChildren: true },
    },
    {
      path: '/list/donations',
      name: 'list-donations',
      component: () => import(/* webpackChunkName: "list-donations" */ './views/donations/DonationsList.vue'),
    },
    {
      path: '/list/givers',
      name: 'list-givers',
      component: () => import(/* webpackChunkName: "list-givers" */ './views/donations/DonationsList.vue'),
      props: { isGiverMode: true },
    },
    {
      path: '/view/contributors/:id',
      name: 'view-contributors',
      component: () => import(/* webpackChunkName: "view-contributors" */ './views/contributors/ContributorsView.vue'),
    },
    {
      path: '/view/projects/:id',
      name: 'view-projects',
      component: () => import(/* webpackChunkName: "view-projects" */ './views/projects/ProjectsView.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/full/Login.vue'),
      meta: { layout: 'full', requiresAuth: false },
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import(/* webpackChunkName: "login" */ './views/full/Logout.vue'),
      meta: { layout: 'full', requiresAuth: false },
    },
    {
      path: '/error-404',
      component: () => import(/* webpackChunkName: "error-404" */ './views/full/Error404.vue'),
      meta: { layout: 'full', requiresAuth: false },
    },
    {
      path: '/not-authorized',
      component: () => import(/* webpackChunkName: "unauthorized" */ './views/full/NotAuthorized.vue'),
      meta: { layout: 'full', requiresAuth: false },
    },
    {
      path: '/redirect',
      component: () => import(/* webpackChunkName: "redirect" */ './views/full/Redirect.vue'),
      meta: { layout: 'full', requiresAuth: false },
      beforeEnter: (to, from, next) => {
        authService.getClientUsername().then(username => {
          if (username) {
            authService.login(username)
              .then(() => next('home'))
              .catch(error => { console.error(error); return next('not-authorized') })
            return null
          }
          return next('login')
        })
        return next()
      },
    },
    { path: '/', redirect: '/redirect' },
    { path: '*', redirect: 'error-404' },
  ],
})

router.beforeEach((to, from, next) => {
  const requiresAuth = (to.meta.requiresAuth !== undefined ? to.meta.requiresAuth : true)
  if (requiresAuth) {
    const isLoggedIn = authService.isLoggedIn()
    if (!isLoggedIn) { return next('redirect') }
  }
  authService.keepAlive()
  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
